// extracted by mini-css-extract-plugin
export var closeButton = "_1g-1";
export var container = "_1g-0";
export var fullModalImage = "_1g-2";